import React from 'react';
import type { TagProps as BaseTagProps } from 'antd';

import { Tag } from './styled.ts';
export type { BaseTagProps };

export const BaseTag: React.FC<BaseTagProps> = ({ className, ...props }) => <Tag className={className} {...props} />;
